import { t } from "i18n-js";
import basicRequest from "../../../../core/redux/actions/request";

import { onChangeInComponents } from "../../cache/l4";

const PREFIX = "MANAGER_PROJECT_SHOW";
const getState = (state) => state.manager.project.show;

const {
    getPattern,

    actionPostPattern,
    actionPutPattern,

    reset,

    isLoaded,
    isLoading,
    getError,
    getData,
} = basicRequest(PREFIX, getState);

export const load = (id) => getPattern("manager/v1/projects/" + id, {}, null);

export { reset, isLoading, isLoaded, getError, getData };

export const toggleComponent = (projectId, posId, componentId) =>
    actionPutPattern(
        `manager/v1/projects/${projectId}/point-of-sale/${posId}/component/${componentId}/toggle`,
        {},
        onChangeInComponents({
            message: "Updated",
            description: "The component was updated.",
        })
    );

export const createComponent = (projectId, posId, form) =>
    actionPostPattern(
        `manager/v1/projects/${projectId}/point-of-sale/${posId}/component`,
        form,
        onChangeInComponents({
            message: "Created",
            description: "The component was created.",
        })
    );

export const updateComponent = (projectId, posId, componentId, form) =>
    actionPutPattern(
        `manager/v1/projects/${projectId}/point-of-sale/${posId}/component/${componentId}`,
        form,
        onChangeInComponents({
            message: "Updated",
            description: "The component was updated.",
        })
    );
